<script>
import { fandomTranslate } from "src/modules/common_module";
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin],
  data: function() {
    return {
      pageModel: globalState.pageModel
    };
  },
  mounted() {
    Fandom.onEvent('complete-registration-required', (data) => {
      this.openModal();
    });
    Vue.nextTick(() => {
      const completeRegistrationRequired = Fandom.readCookie('complete_registration_required');
      console.log(document.cookie);
      if (completeRegistrationRequired) {
        this.openModal();
      }
    });
  },
  methods: {
    ft: fandomTranslate,
    openModal() {
      $("#modal-complete-registration-required").modal({
        backdrop: 'static',
        keyboard: false
      });
      Vue.nextTick(() => {
        $(".modal-backdrop").toggleClass('complete-registration-modal');
      })
    },
    closeModal() {
      Fandom.deleteCookie('complete_registration_required');
      $("#modal-complete-registration-required").modal('hide');
    }
  },
  computed: { }
};
</script>

<template>
  <div modal-complete-registration-component modal-components>
    <div id="modal-complete-registration-required" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-easyadmin="easyadminId" :class="contentType">
          <div class="modal-header border-bottom-0 pb-0">
            <button type="button" class="close" @click="closeModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center px-5 pb-5 pt-4">
            <div class="row justify-content-center">
              <div class="col-12 align-items-center d-none d-md-flex ">
                <h3 class="text-left font-weight-normal text-gray-900">{{content.title}}</h3>
              </div>
              <div class="col-12">
                <generic-form :content="content" :opt-container-content="content" @done="closeModal()"></generic-form>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[modal-complete-registration-component] {

  [generic-form-component]::v-deep {
    color: $dark;

    .form-control {
      border: 1px solid $gray-400;
    }

    .form-group {
      text-align: left;
    }
  }
}
</style>